<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  [formCtrl]="formCtrl"
  ctrlPlaceholder="Izaberite pravo na PDV odbitak"
></kodit-dropdown>
